import { TourService } from './tour.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Video } from '../model/video';
import { VideoPlayerDialogComponent } from '../components/video-player-dialog.component';
import {ComponentFactoryResolver, Injectable, Injector, ViewContainerRef} from '@angular/core';
import { Option } from '../model/option';
import { OptionDetailComponent } from '../components/option-detail.component';
import { Image} from '../model/image';
import { ImageDialogComponent } from '../components/image-dialog.component';

declare function addNoBodyScrollClass();
declare function removeNoBodyScrollClass();

@Injectable()
export class ModalService {

  constructor(private tourService: TourService,
              private dialog: MatDialog) {}

  showModalVideo(video: Video, title: string) {
    if (!video) {
      return;
    }

    video.title = title;

    this.tourService.videoVisibilityChanged.emit(false);

    const config = new MatDialogConfig();
    config.role = 'dialog';
    config.data = video;
    config.disableClose = false;
    config.width = '90%';
    const dialogRef = this.dialog.open(VideoPlayerDialogComponent, config);

    addNoBodyScrollClass();
    dialogRef.afterClosed().subscribe(result => {
      removeNoBodyScrollClass();
    });
  }

  showFullScreenImage(image: Image) {
    const config = new MatDialogConfig();
    config.role = 'dialog';
    config.data = image;
    config.disableClose = false;
    config.height = '100%';
    config.width = '100%';
    config.maxHeight = '100%';
    config.maxWidth = '100%';
    const dialogRef = this.dialog.open(ImageDialogComponent, config);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/modal.service.ts